import {scNamespace} from '../scNamespace'
import Home from '../../views/home'
import Service from '../../views/service'
import Technology from '../../views/technology'
import AboutUs from '../../views/aboutUs'
import Roadmap from '../../views/roadmap'
import Team from '../../views/team'

function buildRouteFromNamespace(namespace, component) {
  let name = namespace.name
  let uri = namespace.uri
  let uriParam = '/:lang?'

  let routeEl = {
    path: uri + uriParam, name: name, component: component
  }

  if(namespace.redirect) {
    routeEl.redirect = namespace.redirect
  }

  return routeEl
}

const scRoutes = [

]

export {
  scRoutes
}